/**
 * Predicates for the "both verdicts Met" rule used to gate the copy-guideline
 * action: the guideline is eligible only when the AI verdict and the human
 * reviewer's verdict both come out Met.
 * @module bothVerdictsMet
 */
import { NCCNEvaluationRecord } from "../../../data-model/nccnEvaluation";
import { HumanVerdict } from "../../../data-model/nccnGuidelines";
import { isAiMet } from "./nccnReviewFeedback";

/**
 * Whether the reviewer recorded a "Met" human verdict on a guideline.
 *
 * @param guideline - The guideline record to inspect, or undefined
 * @returns True when `metadata.human_review.verdict` is Met
 */
export const isHumanMet = (
  guideline: NCCNEvaluationRecord | undefined,
): boolean => guideline?.metadata?.human_review?.verdict === HumanVerdict.Met;

/**
 * Whether both the AI verdict and the human verdict are Met.
 *
 * @param guideline - The guideline record to inspect, or undefined
 * @returns True when the AI result is Met and a human Met verdict is recorded
 */
export const isBothVerdictsMet = (
  guideline: NCCNEvaluationRecord | undefined,
): boolean => isAiMet(guideline) && isHumanMet(guideline);
